import React, { Component } from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import CertificationTestExecutionListCompleted from './CertificationTestExecutionListCompleted';
import CertificationTestExecutionListService from '../services/CertificationTestExecutionListService';

class CertificationTestExecutionListCompletedContainer extends Component {
  certificationTestListService = new CertificationTestExecutionListService();

  componentDidMount() {
    this.certificationTestListService.init('completed');
  }

  render() {
    return (
      <CertificationTestExecutionListCompleted
        certificationTests={toJS(this.certificationTestListService.certificationTests)}
        fetching={this.certificationTestListService.fetch.fetching}
        onDownload={this.certificationTestListService.handleDownloadTemplate}
        onChange={this.certificationTestListService.handleChange}
        pagination={this.certificationTestListService.pagination}
      />
    );
  }
}

export default observer(CertificationTestExecutionListCompletedContainer);
